export default "__VITE_ASSET__9c2cc57d__"